/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            new Site().run();
        };
        Site.prototype.run = function () {
            Site.initResponsiveVideo();
            Site.initResponsiveTables();
            Site.initFrontpage();
            Site.afterDarkDatepicker();
        };
        Site.afterDarkDatepicker = function () {
            var afterDarkForm = document.getElementById("moya_form_afmaeli-after-dark");
            if (afterDarkForm) {
                document.addEventListener("DOMContentLoaded", function () {
                    function isFriday(dateString) {
                        var _a = dateString.split(".").map(Number), day = _a[0], month = _a[1], year = _a[2];
                        var date = new Date(year, month - 1, day);
                        return date.getDay() === 5;
                    }
                    $(".hasDatepicker").each(function () {
                        var $input = $(this);
                        $input.on("change", function () {
                            var selectedDate = $input.val();
                            if (selectedDate && !isFriday(selectedDate)) {
                                alert("Eingöngu er hægt að velja föstudaga");
                                $input.val("");
                            }
                        });
                    });
                });
            }
        };
        Site.is = function (bodyClass) {
            return document.body.classList.contains(bodyClass);
        };
        Site.initResponsiveVideo = function () {
            var iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
            Array.prototype.forEach.call(iframes, function (el) {
                var videoWrapper = document.createElement('div');
                videoWrapper.classList.add('video');
                videoWrapper.style.maxWidth = el.width;
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
                responsiveWrapper.parentNode.insertBefore(videoWrapper, responsiveWrapper);
                videoWrapper.appendChild(responsiveWrapper);
            });
        };
        Site.initResponsiveTables = function () {
            var tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, function (el) {
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        };
        Site.initFrontpage = function () {
            if (!Site.is('frontpage')) {
                return;
            }
            (function () {
                var owl = document.getElementById('days'), owlClassList = owl.classList, owlOptions = {
                    loop: false,
                    dots: false,
                    margin: 30,
                    navText: ["", ""],
                    nav: true,
                    items: 1,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        768: {
                            items: 2,
                        },
                        992: {
                            items: 3,
                        },
                    },
                };
                window.addEventListener('load', function () {
                    if (window.innerWidth < 991) {
                        Site.initOwlCarousel('#days', owlOptions);
                    }
                    else {
                        owlClassList.add('off');
                    }
                }, false);
                window.addEventListener('resize', function () {
                    if (window.innerWidth < 991) {
                        if (owlClassList.contains('off')) {
                            Site.initOwlCarousel('#days', owlOptions);
                            owlClassList.remove('off');
                        }
                    }
                    else {
                        if (!owlClassList.contains('off')) {
                            owlClassList.add('off');
                            var owlC = $('#days');
                            owlC.trigger('destroy.owl.carousel');
                            owlC.find('.owl-stage-outer').children(':eq(0)').unwrap();
                        }
                    }
                });
            })();
        };
        Site.initOwlCarousel = function (id, options) {
            var $owl = $(id);
            if ($owl.length > 0) {
                $owl.addClass('owl-carousel');
                $owl.owlCarousel(options);
            }
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
